import addYears from 'date-fns/addYears';
import startOfDay from 'date-fns/startOfDay';
import startOfToday from 'date-fns/startOfToday';

const MILLISECONDS_IN_HOUR = 60 * 60 * 1000;

const getDestinationToday = (gmt: number) => {
  const userTimeZoneDate = new Date();
  const userTimeZone = userTimeZoneDate.getTimezoneOffset() / 60;

  return startOfDay(userTimeZoneDate.getTime() + (userTimeZone + gmt) * MILLISECONDS_IN_HOUR);
};

const getMinMaxDates = (gmt?: number) => {
  const isGmtValid = typeof gmt === 'number' && !Number.isNaN(gmt);

  const minDate = isGmtValid ? getDestinationToday(gmt) : startOfToday();
  const maxDate = addYears(minDate, 1);

  return {
    minDate,
    maxDate,
  };
};

export default getMinMaxDates;
